import React, { useEffect, useState } from 'react'
import { useRenderUserBadgeMutation } from '../../api/v2/badge'
import { useMyContext } from '../../context/context'
import Button from '../../shared/button'
import { badgeFileName, downloadFile } from '../../utils/badgeFile'

const Badge = () => {
  const myContext = useMyContext() as any
  const [loading, setLoading] = useState<boolean>(true)

  const [downloadBadgeV2] = useRenderUserBadgeMutation()

  const { user } = myContext

  const badgeName = badgeFileName({
    lastName: user?.lastName,
    firstName: user?.firstName,
    code: user?.UserEvent?.code,
    eventName: myContext.event?.name,
  })

  useEffect(() => {
    if (user?.id) {
      downloadBadgeV2({ ...myContext, userId: user?.id })
        .unwrap()
        .then((url: any) => downloadFile(url, badgeName))
        .then(() => setLoading(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadBadgeV2, myContext, user])

  return (
    <div style={{ textAlign: 'center' }}>
      <p>{loading ? 'Votre badge est en cours de téléchargement, veuillez patienter...' : 'Téléchargement terminé'}</p>
      <p>Si votre téléchargement ne fonctionne, veuillez essayer le bouton ci-dessous</p>
      <Button
        style={{ marginTop: '0.5em' }}
        onClick={() => {
          downloadBadgeV2({ ...myContext, userId: user?.id })
            .unwrap()
            .then((url: any) => downloadFile(url, badgeName))
        }}
        label="Je veux relancer le téléchargement"
      />
    </div>
  )
}

export default Badge
